<h3 *ngIf="data.id == null" mat-dialog-title>Cadastrar Tarefa</h3>
<h3 *ngIf="data.id != null" mat-dialog-title>Alterar Tarefa</h3>
<form [formGroup]="form" (ngSubmit)="salvar()">
    <div mat-dialog-content>
        <div style="margin-bottom: 10px; text-align: center" *ngIf="data.id == null">
            <mat-button-toggle-group
                formControlName="isOportunidade"
                aria-label="Tipo de Negócio"
                appearance="legacy"
                style="display: inline-flex; justify-content: center"
            >
                <mat-button-toggle [value]="0" *ngIf="_actions.buttonContactRegistryFiles.enabled"
                    >Registro de Contato</mat-button-toggle
                >
                <mat-button-toggle [value]="2">Relacionamento</mat-button-toggle>
                <mat-button-toggle [value]="1">Oportunidade</mat-button-toggle>
            </mat-button-toggle-group>
        </div>

        <div fxLayout="row wrap">
            <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
                <mat-label>Cliente</mat-label>
                <input
                    matInput
                    placeholder="Digite o nome ou conta de um cliente"
                    aria-label="Cliente"
                    formControlName="cliente"
                    required
                    name="cliente"
                    [matAutocomplete]="auto"
                    [readonly]="data.id != null"
                />
                <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="displayFn"
                    (optionSelected)="getCliente($event.option.value)"
                >
                    <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                        <span> {{ cliente.nome }}</span> |
                        <small>Conta: {{ cliente.numero_xp }}</small>
                    </mat-option>
                </mat-autocomplete>
                <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
                <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
                <mat-error *ngIf="!form.get('cliente')?.valid">Cliente é um campo obrigatório.</mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row wrap">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Assunto</mat-label>
                <mat-select required placeholder="Assunto" formControlName="assunto_id" name="assunto_id">
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option *ngFor="let assunto of listAssunto" [value]="assunto.id">{{ assunto.nome }}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerAssunto"></mat-spinner>
                <mat-error *ngIf="!form.get('assunto_id')?.valid">{{ getErrorAssuntoMessage() }}</mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row wrap">
            <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
                <mat-label>Data</mat-label>
                <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="data_hora_atividade"
                    name="data_hora_atividade"
                    placeholder="Data da Oportunidade"
                    [readonly]="true"
                    required
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div *ngIf="form.get('isOportunidade') && form.get('isOportunidade')?.value == 1" fxLayout="row wrap">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Valor </mat-label>
                <input
                    matInput
                    placeholder="R$ 0,00"
                    formControlName="valor"
                    maxlength="255"
                    currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                />
            </mat-form-field>
        </div>

        <div
            fxLayout="row wrap"
            *ngIf="(form.get('isOportunidade') && form.get('isOportunidade')?.value != 0) || data.id != null"
        >
            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Observação</mat-label>
                <textarea matInput placeholder="Observação" name="observacao" formControlName="observacao" [rows]="5">
                </textarea>
            </mat-form-field>
        </div>

        <div
            fxLayout="row wrap"
            *ngIf="form.get('isOportunidade') && form.get('isOportunidade')?.value == 0 && data.id == null"
        >
            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Resposta</mat-label>
                <textarea matInput placeholder="Resposta" name="resposta" formControlName="resposta" [rows]="5">
                </textarea>
            </mat-form-field>
        </div>

        <div fxLayout="column" class="mb-24">
            <div>
                <!-- Botão para selecionar arquivo -->
                <button type="button" color="primary" mat-raised-button (click)="fileInput.click()">
                    Anexar Arquivo
                </button>

                <input
                    hidden
                    type="file"
                    #fileInput
                    multiple
                    (change)="onFileSelected($event)"
                    accept=".xls,.xlsx,.pdf,.csv,.png,.jpeg,.jpg,.svg,.txt,.doc,.docx,.csi"
                />
            </div>

            <div fxLayout="row wrap">
                <mat-list *ngIf="arquivosSelecionados.length > 0">
                    <mat-list-item *ngFor="let arquivo of arquivosSelecionados; let i = index">
                        <span>{{ arquivo.name }}</span>
                        <button mat-icon-button color="warn" (click)="removerArquivo(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </mat-list-item>
                </mat-list>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button type="button" tabindex="2" (click)="onNoClick()">Cancelar</button>
        <button mat-button type="submit" tabindex="-1" [disabled]="isInvalidForm()">Salvar</button>
    </div>
</form>
